// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N7Xn","label":"styles_label__V93vu"};